__turbopack_context__.v({
  "activeTag": "styles-module__WkTpgW__activeTag",
  "tagLink": "styles-module__WkTpgW__tagLink",
  "tagsNav": "styles-module__WkTpgW__tagsNav",
});
